<template>
  <base-header>
    <ConsoleMenu/>
  </base-header>
</template>

<script>
import BaseHeader from './AppHeader'
import ConsoleMenu from './ConsoleMenu'


export default {
  name: 'AppHeader',
  components: {
    BaseHeader,
    ConsoleMenu,
  },
};
</script>
